import InlineConnection from './components/inlineConnection';

import React, { useLayoutEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { themeConstructorV2 } from './theme/theme';
import { useSelector } from 'react-redux';

import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className'
import Global from './components/dialog/Global';



const ConnectionsWrapper = (props) => {
  const preferences = useSelector((state) => state.preferences);
  const { primaryColor, fontFamily, darkTheme } = preferences;
  const materialTheme = themeConstructorV2(primaryColor, fontFamily, darkTheme);

  useLayoutEffect(() => {
    ClassNameGenerator.configure((componentName) => `hotglue-w-${componentName}`);
  }, [])

  return (
    <ThemeProvider theme={materialTheme}>
      <Global />
      <InlineConnection {...props} />
    </ThemeProvider>
  );
};

export default ConnectionsWrapper;
